import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

type ToggleProps = {
  checked: boolean,
  name: string,
  variant?: "default" | "ai" | "user-confirmed" | "user-added" | "user-removed",
  iconClass?: string,
  accentIconClass?: string,
  title?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Toggle',
  props: {
    checked: { type: Boolean },
    name: null,
    variant: null,
    iconClass: null,
    accentIconClass: null,
    title: null
  },
  emits: ['change'],
  setup(__props: any, { emit }) {

const props = __props as {
  checked: boolean,
  name: string,
  variant?: "default" | "ai" | "user-confirmed" | "user-added" | "user-removed",
  iconClass?: string,
  accentIconClass?: string,
  title?: string,
};




const variantClass = computed(() => `switch-${props.variant || "default"}`);

function onToggle() {
  emit('change', !props.checked);
}

return { __sfc: true,props, emit, variantClass, onToggle }
}

})